import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent {
  @Input() value: any = '';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();

  isEditing: boolean = false;
  tempValue: any = '';

  showInput() {
    if (!this.disabled) {
      this.isEditing = true;
      this.tempValue = this.value;
    }
  }

  save() {
    this.value = this.tempValue;
    this.valueChange.emit(this.value);
    this.onSave.emit(this.value);
    this.isEditing = false;
  }

  cancel() {
    this.tempValue = this.value;
    this.isEditing = false;
    this.onCancel.emit();
  }
} 